<template>
  <tutorial :show="showTutorial" :show-bus="showBus" :numPages="4">
    <template slot="title">
      {{ $t("components.tutorials.tutorial_match.title") }}
    </template>
    <template slot="text">
      {{ $t("components.tutorials.tutorial_match.info_1") }}
    </template>
    <template slot="image" slot-scope="modal">
      <img
        :src="localizedSource('tutorial-f02-01.png')"
        v-show="modal.page === 0"
        alt=""
      />
      <img
        :src="localizedSource('tutorial-f02-02.png')"
        v-show="modal.page === 1"
        alt=""
      />
      <img
        :src="localizedSource('tutorial-f02-03.png')"
        v-show="modal.page === 2"
        alt=""
      />
      <img
        :src="localizedSource('tutorial-f02-04.png')"
        v-show="modal.page === 3"
        alt=""
      />
    </template>
  </tutorial>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LocalizedImageMixin } from "@/utils/LocalizedImageMixin";
import { TutorialMixin } from "@/utils/TutorialMixin";

import Tutorial from "../layouts/Tutorial";
import Vue from "vue";
import { ProgressStepId } from "@/utils/ProgressStepId";
import { ProgressState } from "@/utils/ProgressState";

export default {
  name: "TutorialMatch",
  mixins: [LocalizedImageMixin, TutorialMixin],
  components: {
    Tutorial
  },
  props: {
    showBus: {
      type: Vue,
      default: null
    }
  },
  data: () => ({
    showTutorial: false
  }),
  created() {
    this.checkProgression();
  },
  computed: {
    ...mapGetters("user", ["user", "hasProgress"])
  },
  methods: {
    ...mapActions("user", ["updateProgression"]),
    checkProgression() {
      let hasSeenTutorial = this.hasProgress(ProgressStepId.TutorialMatch);
      if (!hasSeenTutorial) {
        this.showTutorial = true;
        this.updateProgression({
          key: ProgressStepId.TutorialMatch,
          data: { state: ProgressState.Completed }
        });
      }
    }
  }
};
</script>
